/**
 * 项目统一配置
 */
export default {

    //配后端数据的接收方式application/json;charset=UTF-8或者application/x-www-form-urlencoded;charset=UTF-8
      contentType: 'application/json;charset=UTF-8',
        //最长请求时间
      requestTimeout: 30000,
       //需要加loading层的请求，防止重复提交
      debounce: [],
      //加载时显示文字
      loadingText: '正在加载中...',
  
      version: '1.0',
      
      name: '源计划建筑设计（广州）有限公司',  // 项目名称

      baseURL: 'http://api.o-officearch.com/api/business',  // 接口地址     

     // baseURL: 'http://yzl.dianjisite.com/api/business',  // 接口地址
     
    //  baseURL: 'http://192.168.0.168:8089/api/business',  // 接口地址

      defaultLanguage:'cn',
      languageName:'language',

      imageUrl:'http://api.o-officearch.com/',

     // imageUrl:'http://yzl.dianjisite.com',

     // imageUrl:'http://192.168.0.168:8089',


  }